import React from 'react';
import {
  IonRadioGroup,
  IonItem,
  IonLabel,
  IonRadio
} from '@ionic/react';
import { useTranslation } from 'react-i18next';

interface AlphabetQuestionProps {
  onAnswer: (knows: boolean) => void;
}

export const AlphabetQuestion: React.FC<AlphabetQuestionProps> = ({ onAnswer }) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center h-full px-6">
      <IonRadioGroup 
        onIonChange={e => onAnswer(e.detail.value === 'yes')}
        className="w-full max-w-md bg-[#1C1C1E] rounded-2xl p-6"
      >
        <IonItem lines="none" className="--ion-item-background: transparent;">
          <IonLabel className="text-white text-xl font-medium text-center py-4">
            {t('russianTutor.askAboutAlphabet')}
          </IonLabel>
        </IonItem>
        <IonItem lines="none" className="--ion-item-background: transparent; my-2">
          <IonLabel className="text-white">{t('russianTutor.yes')}</IonLabel>
          <IonRadio slot="start" value="yes" className="--color: #31D526" />
        </IonItem>
        <IonItem lines="none" className="--ion-item-background: transparent; my-2">
          <IonLabel className="text-white">{t('russianTutor.no')}</IonLabel>
          <IonRadio slot="start" value="no" className="--color: #31D526" />
        </IonItem>
      </IonRadioGroup>
    </div>
  );
};